// Simulated meeting transcript used when the live microphone path is unavailable
// (e.g. no mic permission, or the live service is off). It powers the same
// lyrics-style animation so the demo always feels alive.

export interface DemoLine {
  speaker: string;
  speakerLabel: string;
  text: string;
  /** ms to "type out" this line before advancing */
  hold: number;
}

export const DEMO_LINES: DemoLine[] = [
  {
    speaker: "host",
    speakerLabel: "Chủ trì",
    text: "Xin mời các đồng chí ổn định, chúng ta bắt đầu phiên họp giao ban tuần.",
    hold: 3400,
  },
  {
    speaker: "host",
    speakerLabel: "Chủ trì",
    text: "Nội dung hôm nay tập trung vào tiến độ triển khai dịch vụ công trực tuyến.",
    hold: 3600,
  },
  {
    speaker: "s1",
    speakerLabel: "Phòng Nghiệp vụ",
    text: "Báo cáo, đến nay đã số hoá được tám mươi hai phần trăm hồ sơ thủ tục.",
    hold: 3600,
  },
  {
    speaker: "s1",
    speakerLabel: "Phòng Nghiệp vụ",
    text: "Còn vướng phần đồng bộ dữ liệu với hệ thống một cửa của tỉnh.",
    hold: 3400,
  },
  {
    speaker: "host",
    speakerLabel: "Chủ trì",
    text: "Đề nghị phối hợp với bên kỹ thuật, hoàn thành trước ngày ba mươi tháng này.",
    hold: 3800,
  },
  {
    speaker: "s2",
    speakerLabel: "Phòng Kỹ thuật",
    text: "Chúng tôi sẽ bố trí nhân sự, cam kết xử lý dứt điểm trong hai tuần.",
    hold: 3600,
  },
  {
    speaker: "host",
    speakerLabel: "Chủ trì",
    text: "Tốt. Vậy chốt lại ba nhiệm vụ và giao mốc thời gian cụ thể cho từng đơn vị.",
    hold: 4000,
  },
  {
    speaker: "s3",
    speakerLabel: "Văn phòng",
    text: "Vâng, tôi sẽ tổng hợp kết luận và gửi biên bản ngay sau cuộc họp.",
    hold: 3400,
  },
];
